<template>
  <div :style="{ 'height': height }">
    <div class="title">
      变量
    </div>
    <el-collapse v-model="activeName" :disabled="disabled" :accordion="accordion">
      <el-collapse-item v-for="item in tableData" :key="item[nodeKey.text]" :name="item[nodeKey.text]">
        <template slot="title">
          <span class="gj-pl20"></span>{{ item[nodeKey.text] }}
        </template>
        <div class="margin_left_36 column_sta">
          <div :class="[{'curnot': disabled}, 'collapse-content', 'text-ellipsis-1', 'colorBlue']"
            v-for="items in item[nodeKey.children]" :key="items[nodeKey.id]"
            @click="select(nodeKey.children, items)">
            {{ items[nodeKey.text] }}
            <i v-if="items.isActive" class="el-icon-check"></i>
          </div>
        </div>
      </el-collapse-item>
    </el-collapse>
  </div>
</template>

<script>
import { queryMailTemplateVariable, templateList } from "@/api/crm";
export default ({
  name: 'gj-variable-select',
  props: {
    height: {
      type: String,
      default: '500px'
    },
    disabled: {
      type: Boolean,
      default: false
    },
    // 手风琴效果
    accordion: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      activeName: null,
      activeItem: null,
      tableData: [],
      name: "",
      nodeKey: {
        id: 'variableValue',
        text: 'variableText',
        children: 'mailTemplateVariableList',
      },
    }
  },
  created() {
    queryMailTemplateVariable().then((res) => {
      this.tableData = res;
    });
  },
  methods: {
    select(key, item) {
      if(this.disabled) {
        return false
      }
      this.$emit("templateRow", item);
    }
  },
})
</script>

<style lang="scss">
.gj-cascader-select {
  .title {
    height: 31px;
    border-top: 1px solid #D8DADD;
    border-left: 1px solid #D8DADD;
    border-right: 1px solid #D8DADD;
    line-height: 31px;
    padding-left: 12px;
    background: #F6F7F8;
  }

  .el-icon-search {
    font-size: 18px
  }

  .el-collapse {
    background: #fff;
    overflow-Y: auto;
    height: calc(100% - 32px);
    border: 1px solid #D8DADD;
    font-size: 12px;

    .el-collapse-item {
      position: relative;
      .el-collapse-item__content {
        padding-bottom: 0
      }
    }

    .el-collapse-item__header {
      height: 38px;
      line-height: 38px;
      border-bottom: 1px solid #D8DADD;
      padding-left: 10px;

      &.is-active {
        border-bottom: 1px solid #D8DADD;
      }

      .margin_0_10 {
        margin: 0 10px;
      }

      .el-collapse-item__arrow {
        position: absolute;
        left: 10px;
      }
    }

    .el-collapse-item__wrap {
      border-bottom: 1px solid #D8DADD;
    }



    .el-button {
      margin-left: 0;
    }
  }

  .column_sta {
    .collapse-content {
      height: 38px;
      line-height: 38px;
      // border-bottom: 1px solid #D8DADD;
      padding: 0 31px;
      color: #666666;
      cursor: pointer;

      .el-icon-check {
        float: right;
        margin-top: 12px;
        font-size: 15px;
      }
    }

    .curnot{
      cursor:not-allowed;
    }

    .collapse-content-active {
      color: #1F6EEF;
      background: #EEF3FB;

      .el-icon-check {
        color: #1F6EEF;
      }
    }

    :last-child {
      border-bottom: 0 !important;
    }
  }
}
</style>
